import React from "react";

function Hero(){

  return(
    <div className="hero">

      <div className="hero-content">
        <h1>Share Your Ideas With The World</h1>
        <p>
          Discover innovative ideas and support creators from
          around the globe.
        </p>
      </div>

      <div className="wave">
        <svg viewBox="0 0 1440 320">
          <path fill="#f4f6f9" fillOpacity="1"
          d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,112C840,117,960,171,1080,192C1200,213,1320,203,1380,197.3L1440,192L1440,320L0,320Z">
          </path>
        </svg>
      </div>
<div className="glass-form">
    </div>
    </div>
  )
}

export default Hero;